import React, { Component } from "react";
import { Segment, Grid, Button } from "semantic-ui-react";
import { isMobile } from "react-device-detect";
import { get } from "lodash";
import PersonReport from "./PersonReport";
import PersonPlatinumReport from "./PersonPlatinumReport";
import PersonSilverReport from "./PersonSilverReport";
import PersonGoldReport from "./PersonGoldReport";
import StickyNav from "./StickyNav";

class ReportRoot extends Component {
  constructor(props) {
    super(props);
    this.state = { showNav: true };
  }

  toggleReportInclude = () => {
    this.setState({ showNav: !this.state.showNav });
  };

  renderThisContent = () => {
    // const { isGoldReport } = this.props;
    const isSilvRep = this.isSilverReport;
    const isGoldReport = !isSilvRep &&
      (get(this.props.reportData, "personReport.response[0].output[0].extendedReports") !== undefined
        || get(this.props.reportData, "personReport.log[0].reportID[0]") === "23"
        // || get(this.props.reportData, "personReport.log[0].reportID[0]") === "58"
      );
    if (isMobile) {
      return (
        <Segment key="tabContent1" attached>
          <Grid stackable>
            <Grid.Row>
              {this.state.showNav ? (
                <Grid.Column width={13}>
                  <StickyNav
                    onReportIndexChanged={this.onReportIndexChanged}
                    {...this.props}
                  />
                </Grid.Column>
              ) : null}
              <Grid.Column width={2}>
                <Button
                  circular
                  size={"tiny"}
                  onClick={this.toggleReportInclude}
                  className="float-right close-left-menu-button"
                >
                  {this.state.showNav ? "<" : ">"}
                </Button>
              </Grid.Column>
              <Grid.Column
                width={this.state.showNav ? 16 : 16}
                className="padding-top-20"
              >
                {isGoldReport && (
                  <PersonGoldReport
                    isSilverReport
                    isGoldReport
                    {...this.props}
                  />
                )}
                {isSilvRep && (
                  <PersonSilverReport isSilverReport {...this.props} />
                )}
                {!(isSilvRep || isGoldReport) &&
                  (this.props.isPlatinumReport !== undefined &&
                    this.props.isPlatinumReport ? (
                    <PersonPlatinumReport {...this.props} />
                  ) : (
                    <PersonReport {...this.props} />
                  ))}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      );
    }
    return (
      <Segment key="tabContent1" attached>
        <Grid columns={3} stackable>
          <Grid.Row>
            {this.state.showNav ? (
              <Grid.Column width={3}>
                <StickyNav
                  onReportIndexChanged={this.onReportIndexChanged}
                  {...this.props}
                />
              </Grid.Column>
            ) : null}
            <Grid.Column width={1}>
              <Button
                circular
                size={"tiny"}
                onClick={this.toggleReportInclude}
                className="position-fixed float-right close-left-menu-button"
              >
                {this.state.showNav ? "<" : ">"}
              </Button>
            </Grid.Column>
            <Grid.Column width={this.state.showNav ? 12 : 15}>
              {isGoldReport && (
                <PersonGoldReport isSilverReport isGoldReport {...this.props} />
              )}
              {isSilvRep && (
                <PersonSilverReport isSilverReport {...this.props} />
              )}
              {!(isSilvRep || isGoldReport) &&
                (this.props.isPlatinumReport !== undefined &&
                  this.props.isPlatinumReport ? (
                  <PersonPlatinumReport {...this.props} />
                ) : (
                  <PersonReport {...this.props} />
                ))}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  };

  render() {
    return this.renderThisContent();
  }
}

export default ReportRoot;



// WEBPACK FOOTER //
// ./src/components/reports/ReportRoot.js